import React, { useState, useRef, useEffect } from 'react';
import './playbackSpeedDropDown.css'; 
import { DownIcon, UpIcon } from './Icons.tsx';

export default function PlaybackSpeedDropDown({ playbackSpeed, handlePlaybackSpeedChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const speedOptions = [
    { label: '0.25X', value: '0.25' },
    { label: '0.5X', value: '0.5' },
    { label: '1X', value: '1' },
    { label: '1.5X', value: '1.5' },
    { label: '2X', value: '2' },
    { label: '3X', value: '3' },
  ];

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  // Find the label for the current playback speed value
  const getSpeedLabel = (value) => {
    const option = speedOptions.find((opt) => opt.value === value.toString()); // Make sure to compare string values
    return option ? option.label : '1X';
  };

  const handleOptionClick = (value) => {
    const simulatedEvent = { target: { value } }; // Simulate event object with target.value
    handlePlaybackSpeedChange(simulatedEvent); // Pass the simulated event to the handler
    setIsOpen(false); // Close the dropdown
  };

  return (
    <div className="playback-dropdown-wrapper" ref={dropdownRef}>
      <button
        style={{ color: "#333", backgroundColor: "white",fontSize:"13px",border:"none",outline: "none",fontWeight:"600" }}
        className="playback-speed-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        {getSpeedLabel(playbackSpeed)} {/* Display the label based on the current speed value */}
        {!isOpen ? <DownIcon  /> : <UpIcon />}
      </button>
      {isOpen && (
        <div className="playback-dropdown-list" style={{ bottom: '100%' }}>
          {speedOptions.map((opt) => (
            <button
              key={opt.value}
              onClick={() => handleOptionClick(opt.value)} // Only call the function once
              style={{ color: "#333" }}
              className={`playback-dropdown-item ${opt.value === playbackSpeed.toString() ? 'active' : ''}`} // Highlight active option by comparing string
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
